export default {
	title: 'Region Visits Rate',
	'incomplete-visits-banner': 'You have ({count}) incomplete visits on: {date}',
	visited: 'Visited',
	'not-visited': 'Not visited',
	'unknown-customer': 'Unknown customer',
	'no-statistics': 'No statistics for this day',
}
